module.exports = __webpack_public_path__ + "25a685ab9ef5c05ece28b54dcf43d5f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/golden-doge.png
// module id = FlnO
// module chunks = 0